import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"
import axios from "axios"

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

export const getProducts = async (token, options = {}) => {
    log("welcome in getProducts")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const params = {}
        if (options.client_id) params.client_id = options.client_id
        if (options.search_term) params.search_term = options.search_term

        const result = await axios.get(BASE_URL + '/home/getProductsApi', {
            headers: getHeaders(token),
            params
        })
        return result.data
    } catch (err) {
        log("Error in getProducts", err)
        return { error: true, message: "Error loading products" }
    }
}

export const getProductCodesForProvisioning = async (token) => {
    log("welcome in getProductCodesForProvisioning")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getProductCodesForProvisioningApi', {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in getProductCodesForProvisioning", err)
        return { error: true, message: "Error loading product codes for provisioning" }
    }
}

export const getProductDetails = async (token, productId) => {
    log("welcome in getProductDetails")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getProductDetailsApi', {
            headers: getHeaders(token),
            params: { product_id: productId }
        })
        return result.data
    } catch (err) {
        log("Error in getProductDetails", err)
        return { error: true, message: "Error loading product details" }
    }
}

export const createProduct = async (token, data) => {
    log("welcome in createProduct")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/createProductApi', data, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in createProduct", err)
        return { error: true, message: "Error creating product" }
    }
}

export const updateProduct = async (token, data) => {
    log("welcome in updateProduct")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.put(BASE_URL + '/home/updateProductApi', data, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in updateProduct", err)
        return { error: true, message: "Error updating product" }
    }
}

export const deleteProduct = async (token, productId) => {
    log("welcome in deleteProduct")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.delete(BASE_URL + '/home/deleteProductApi', {
            headers: getHeaders(token),
            params: { product_id: productId }
        })
        return result.data
    } catch (err) {
        log("Error in deleteProduct", err)
        return { error: true, message: "Error deleting product" }
    }
}

export const allocateProductToDistributor = async (token, productId, distributorId) => {
    log("welcome in allocateProductToDistributor")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/allocateProductToDistributorApi', {
            product_id: productId,
            distributor_id: distributorId
        }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in allocateProductToDistributor", err)
        return { error: true, message: "Error allocating product" }
    }
}

export const deallocateProductFromDistributor = async (token, productId, distributorId) => {
    log("welcome in deallocateProductFromDistributor")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/deallocateProductFromDistributorApi', {
            product_id: productId,
            distributor_id: distributorId
        }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in deallocateProductFromDistributor", err)
        return { error: true, message: "Error deallocating product" }
    }
}

export const getProductAllocations = async (token, options = {}) => {
    log("welcome in getProductAllocations")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const params = {}
        if (options.distributor_id) params.distributor_id = options.distributor_id
        if (options.product_id) params.product_id = options.product_id

        const result = await axios.get(BASE_URL + '/home/getProductAllocationsApi', {
            headers: getHeaders(token),
            params
        })
        return result.data
    } catch (err) {
        log("Error in getProductAllocations", err)
        return { error: true, message: "Error loading product allocations" }
    }
}

export const getAvailableProductsForDistributor = async (token, distributorId = null) => {
    log("welcome in getAvailableProductsForDistributor")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const params = {}
        if (distributorId) params.distributor_id = distributorId

        const result = await axios.get(BASE_URL + '/home/getAvailableProductsForDistributorApi', {
            headers: getHeaders(token),
            params
        })
        return result.data
    } catch (err) {
        log("Error in getAvailableProductsForDistributor", err)
        return { error: true, message: "Error loading available products" }
    }
}

export const getDistributorClients = async (token, searchTerm = null) => {
    log("welcome in getDistributorClients")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const params = {}
        if (searchTerm) params.search_term = searchTerm

        const result = await axios.get(BASE_URL + '/home/getDistributorClientsApi', {
            headers: getHeaders(token),
            params
        })
        return result.data
    } catch (err) {
        log("Error in getDistributorClients", err)
        return { error: true, message: "Error loading distributor clients" }
    }
}

export default {
    getProducts,
    getProductDetails,
    createProduct,
    updateProduct,
    deleteProduct,
    allocateProductToDistributor,
    deallocateProductFromDistributor,
    getProductAllocations,
    getAvailableProductsForDistributor,
    getDistributorClients
}
